module.exports = __webpack_public_path__ + "static/media/PerkinsGenerator.04352b3c.png";